import { renderToString } from "react-dom/server";
import PieChartTooltip from "app/pages/app-intelligence/app-analysis/components/GenericGraph/components/PieChartTooltip";
import {
    combineConfigs,
    noMarginConfig,
    noMarkerConfig,
    tooltipContainerConfig,
} from "@similarweb/pro-logic-components";
import { getValueAsPercentage } from "app/pages/keyword-research/keyword-analysis/pages/keywords-overview/serp-composition/serpCompositionUtils";

export const chartConfig = combineConfigs({}, [
    noMarkerConfig,
    noMarginConfig,
    {
        chart: {
            height: "100%",
            width: 88,
        },
        plotOptions: {
            pie: {
                size: 88,
                states: {
                    hover: {
                        brightness: 0,
                    },
                    inactive: {
                        opacity: 0.5,
                    },
                },
            },
        },
        tooltip: {
            enabled: true,
            followPointer: true,
            headerFormat: ``,
            ...tooltipContainerConfig().tooltip,
            pointFormatter() {
                const name = this.name;
                const color = this.color as string;
                const percent = getValueAsPercentage(this.y);

                const props = {
                    name,
                    color,
                    value: percent,
                };

                return renderToString(<PieChartTooltip {...props} />);
            },
        },
    },
]);
